import React from 'react';

import FitmentTireSizeOeDropdownOptionTireSize from './fitment-tire-size-oe-dropdown-option-tire-size';

import { parseTireSize } from '../../../../../../../shared/utils/fitment/fitment';

interface FitmentTireSizeOeDropdownOptionDetailsProps {
  isSize: boolean;
  isStaggered: boolean;
  label: string;
  tireDescriptions: string[];
}

function FitmentTireSizeOeDropdownOptionDetails(
  props: FitmentTireSizeOeDropdownOptionDetailsProps
) {
  const { isSize, isStaggered, label, tireDescriptions } = props;

  if (!isSize) {
    return <span>{label}</span>;
  }

  if (isStaggered) {
    const [frontTire, rearTire] = tireDescriptions;

    return (
      <>
        <FitmentTireSizeOeDropdownOptionTireSize
          description="O.E Front:"
          diameter={parseTireSize(frontTire)?.diameter}
          label={frontTire}
        />
        <FitmentTireSizeOeDropdownOptionTireSize
          description="O.E Rear:"
          diameter={parseTireSize(rearTire)?.diameter}
          label={rearTire}
        />
      </>
    );
  }

  return (
    <FitmentTireSizeOeDropdownOptionTireSize
      description="O.E"
      diameter={parseTireSize(label)?.diameter}
      label={label}
    />
  );
}

export default FitmentTireSizeOeDropdownOptionDetails;
